import { Type } from './types';
import { FormType } from '@lenderful/domain';
import { redirectToNewFrom } from '../../reducers/router';
import { TransferToFormCode } from '../../models/fields/conditionals';
import { REVERSE_LOAN_GOAL } from '../../models/sections/constants';

/**
 * Redirects from the Loan Officer form to the selected form.
 * @param payload
 */
export function handleLoanOfficerRedirect(payload) {
  return (dispatch) => {
    dispatch({ type: Type.HANDLE_LOAN_OFFICER_REDIRECT, payload });

    return dispatch(redirectToNewFrom({
      answeredQuestions: [],
      code: '' as TransferToFormCode,
      condition: () => true,
      fromForm : FormType.LOAN_OFFICER,
      toForm: FormType.REVERSE,
      sectionId: REVERSE_LOAN_GOAL.toString(),
    }));
  };
}
